import { render } from "./blackList.vue?vue&type=template&id=e0e1f4fe&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"

import "./blackList.vue?vue&type=style&index=0&id=e0e1f4fe&scoped=true&lang=css"
import "./blackList.vue?vue&type=style&index=1&id=e0e1f4fe&lang=css"
script.render = render
script.__scopeId = "data-v-e0e1f4fe"

export default script